import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { apiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function AdminLogin() {
  const { login, logout } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      if (!u.is_admin) {
        logout();
        toast.error("Those credentials aren't for an admin account.");
        return;
      }
      toast.success(`Welcome, ${u.display_name}`);
      nav("/admin");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-0 py-16">
      <div className="paper-card p-8" style={{ borderColor: "rgba(224,64,251,0.35)" }} data-testid="admin-login-card">
        <div className="flex items-center gap-2 overline mb-2">
          <ShieldCheck size={12} /> Staff access
        </div>
        <h1 className="rainbow-text text-3xl mb-2">Admin sign-in</h1>
        <p className="text-xs mb-6" style={{ color: "var(--ink-muted)" }}>
          Restricted area — non-admin accounts will be logged out immediately.
        </p>

        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <Label htmlFor="admin-email">Admin email</Label>
            <Input
              id="admin-email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <Label htmlFor="admin-password">Password</Label>
            <Input
              id="admin-password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full btn-press btn-rainbow"
            data-testid="admin-login-submit"
          >
            {loading ? "Signing in…" : "Enter Control Room"}
          </Button>
        </form>
      </div>
    </div>
  );
}
